export default [
    {
        name: 'Ticket Refeição',
        value: 'ticket_vr'
    },
    {
        name: 'Visa',
        value: 'visa'
    },
    {
        name: 'Master Card',
        value: 'MasterCard'
    },
]